import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Category } from '../models/category.model';
import { BaseService } from '../../../shared/services/base.service';
import { CategoryFilter } from '../models/category-filter.model';

@Injectable()
export class CategoryService extends BaseService {

  
  controllerName: string = "ApiECommerceInventory";
  urlGetAll = "getallcategories"
  urlGetAllItemsByCategoryId = "getallitemsbycategoryid";
  urlGetAllItems = "GetAllItems";
  urlGetMinMaxPrice = "GetMinMaxPrice";
  urlGetAllItemsByMaxPriceAndLatestDate= "GetAllItemsByMaxPriceAndLatestDate";
  filter= "Filter";
  ////////////////////////////////////////////////////////////////////////////////////
  public header = new HttpHeaders().set(
    "access-token",this.token
  );
/////////////////////////////////////////////////////////////////
  getAllItemsByCategoryId(categoryFilter: CategoryFilter): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetAllItemsByCategoryId}?categoryid=${categoryFilter.CategorId}&start=${categoryFilter.Start}&end=${categoryFilter.End}&searchvalue=&orderby=&dir=`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getAllItems(categoryFilter: CategoryFilter): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetAllItems}?start=${categoryFilter.Start}&end=${categoryFilter.End}&searchvalue=${categoryFilter.SearchValue}&orderby=&dir=`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
getMinMaxPrice(searchValue : string,categoryId :number): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetMinMaxPrice}?searchValue=${searchValue}&categoryId=${categoryId}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getAllItemsByMaxPriceAndLatestDate(categoryFilter: CategoryFilter,maxPrice:number,latestDate:Date): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetAllItemsByMaxPriceAndLatestDate}?start=${categoryFilter.Start}&end=${categoryFilter.End}&searchvalue=${categoryFilter.SearchValue}&orderby=&dir=&maxPrice=${maxPrice}&latestDate=${latestDate}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
Filter(categoryFilter: CategoryFilter,startPrice:number,endPrice:number,availability:boolean):any{
  return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.filter}?start=${categoryFilter.Start}&end=${categoryFilter.End}&nameSearchValue=${categoryFilter.SearchValue}&orderby=${categoryFilter.Orderby}&dir=${categoryFilter.Dir}&categoryId=${categoryFilter.CategorId}&startPrice=${startPrice}&endPrice=${endPrice}&availability=${availability}`,{headers:this.header});
}

}